module.exports = __webpack_public_path__ + "/build/web/images/logos/id-inspired-drapes/id-inspired-drapes.6f1aafa625bd5abcaddb5cfb87b7871b.png";


//////////////////
// WEBPACK FOOTER
// ./images/logos/id-inspired-drapes/id-inspired-drapes.png
// module id = 163
// module chunks = 13